export const ActionTypes = {
  Exchange: 'exchange',
  Return: 'return',
  Claim: 'claim',
};

export const ItemsLayouts = {
  ItemView: 'item_view',
  ShipmentView: 'shipment_view',
};

export const ClaimReasons = {
  PackageMissing: 'PackageMissing',
};

export const ItemEventStatus = {
  ItemStatusClaimOpened: 'ITEM_STATUS_CLAIM_OPENED',
  ItemStatusClaimApproved: 'ITEM_STATUS_CLAIM_APPROVED',
  ItemStatusClaimRejected: 'ITEM_STATUS_CLAIM_REJECTED',
};

export const ReturnMethods = {
  Mail: 'mail',
  PrinterlessMail: 'printerless_mail',
  Boxless: 'boxless',
  Digital: 'digital',
  Pickup: 'pickup',
  Concierge: 'concierge',
  Self: 'self',
  HomePickup: 'home_pickup',
  LockerDropoff: 'locker_dropoff',
  ConciergePartnership: 'concierge_partnership',
  Store: 'store',
};

export const ReturnDateViewType = {
  Dynamic: 'DYNAMIC',
  ItemsCard: 'ITEMS_CARD',
  Default: 'DEFAULT'
};